<template>
  <div class="infoBox">
    <!-- <h2 class="main" style="text-align: center;"><span v-if="info.country!=undefined && info.country.length>0">{{info.country}}</span><span v-if="info.classifyName!=undefined && info.classifyName.length>0">-{{info.classifyName}}</span><span v-if="info.thisYear!=undefined && info.thisYear.length>0">-{{info.thisYear}}</span></h2> -->
    <h2 class="main" style="text-align: center;">
      <div v-if=" info.bigType == 246 || info.bigType==247 || info.bigType==248 || info.bigType==249 
          || info.bigType==250 || info.bigType==253 || info.bigType==254 || info.bigType==255 
          || info.bigType==256 || info.bigType==257 || info.bigType==258 || info.bigType==259 ">
        <span v-if="info.country!=undefined && info.country.length>0">{{info.country}}</span><span v-if="info.frontDesc!=undefined && info.frontDesc.length>0">-{{info.frontDesc}}</span><span v-if="info.classifyName!=undefined && info.classifyName.length>0">-{{info.classifyName}}</span>
      </div>
      <div v-else>
        <span v-if="info.country!=undefined && info.country.length>0">{{info.country}}</span><span v-if="info.classifyName!=undefined && info.classifyName.length>0">-<span v-html="info.classifyName"></span></span><span v-if="info.thisYear!=undefined && info.thisYear.length>0">-{{info.thisYear}}{{info.castMark}}</span>
      </div>
    </h2>
    <!-- 古代就是中国选项下的民国以前的 -->
    <div class="create_time">创建时间：{{ info.createTime }}</div>
    <div style="text-align:center;"> <img :src="info.smallPic" width="200" height="200" class="img" />
      <img :src="info.reverseSmallPic" width="200" height="200" class="img" />
    </div>
    <h3>信息: </h3>
    <div v-if=" info.bigType == 246 || info.bigType==247 || info.bigType==248 || info.bigType==249 
          || info.bigType==250 || info.bigType==253 || info.bigType==254 || info.bigType==255 
          || info.bigType==256 || info.bigType==257 || info.bigType==258 || info.bigType==259 ">
    <table>
      <!-- <tbody>
        <tr>
          <th>国家</th>
          <td>{{info.country}}</td>
        </tr>
        <tr>
          <th>面值</th>
          <td>{{info.classifyName}}</td>
        </tr>
        <tr>
          <th>年份</th>
          <td>{{info.thisYear}}</td>
        </tr>
        <tr>
          <th>硬币类型</th>
          <td>{{info.coinTypeName}}</td>
        </tr>
        <tr>
          <th>成分</th>
          <td>{{info.component}}</td>
        </tr>
        <tr>
          <th>边缘类型</th>
          <td>{{info.edge}}</td>
        </tr>
        <tr>
          <th>形状</th>
          <td>{{info.shape}}</td>
        </tr>
        <tr>
          <th>正背面对齐类型</th>
          <td>{{info.frontBack}}</td>
        </tr>
        <tr>
          <th>重量（克）</th>
          <td>{{info.weight}}</td>
        </tr>
        <tr>
          <th>直径（毫米）</th>
          <td>{{info.diameter}}</td>
        </tr>
        <tr>
          <th>厚度（毫米）</th>
          <td>{{info.thick}}</td>
        </tr>
      </tbody> -->

          <tbody>
            <tr>
              <th>朝代</th>
              <td>{{info.country}}</td>
            </tr>
            <tr>
              <th>年代</th>
              <td>{{info.thisYear}}</td>
            </tr>
            <tr>
              <th>钱文</th>
              <td>{{info.moneyText}}</td>
            </tr>
            <tr>
              <th>面文</th>
              <td>{{info.frontDesc}}</td>
            </tr>
            <tr>
              <th>背文</th>
              <td>{{info.backDesc}}</td>
            </tr>
            <tr>
              <th>面值</th>
              <td>{{info.faceValue}}</td>
            </tr>
            <tr>
              <th>直径（毫米）</th>
              <td>{{info.diameter}}</td>
            </tr>
            <tr>
              <th>重量（克）</th>
              <td>{{info.weight}}</td>
            </tr>
            <tr>
              <th>厚度（毫米）</th>
              <td>{{info.thick}}</td>
            </tr>
            <tr>
              <th>统治者</th>
              <td>{{info.templeName}}-{{info.name}}</td>
            </tr>
            <tr>
              <th>类型</th>
              <td>{{info.coinTypeName}}</td>
            </tr>
            <tr>
              <th>备注</th>
              <td>{{info.content}}</td>
            </tr>
          </tbody> 
    </table>
    </div>
    <div  v-else>
      <table>
        <tbody>
          <tr>
            <th>国家或地区</th>
            <td>{{info.country}}</td>
          </tr>
          <tr>
            <th>面值</th>
            <td><span v-html="info.classifyName"></span></td>
          </tr>
          <tr>
            <th>年份</th>
            <td>{{info.thisYear}}</td>
          </tr>
          <tr>
            <th>硬币类型</th>
            <td>{{info.coinTypeName}}</td>
          </tr>
          <tr>
            <th>成分</th>
            <td>{{info.component}}</td>
          </tr>
          <tr>
            <th>边缘类型</th>
            <td>{{info.edge}}</td>
          </tr>
          <tr>
            <th>形状</th>
            <td>{{info.shape}}</td>
          </tr>
          <tr>
            <th>正背面对齐类型</th>
            <td>{{info.frontBack}}</td>
          </tr>
          <tr>
            <th>重量（克）</th>
            <td>{{info.weight}}</td>
          </tr>
          <tr>
            <th>直径（毫米）</th>
            <td>{{info.diameter}}</td>
          </tr>
          <tr>
            <th>厚度（毫米）</th>
            <td>{{info.thick}}</td>
          </tr>
          <tr>
            <th>铸币厂</th>
            <td>{{info.mint}}</td>
          </tr>
          <tr>
            <th>发行量</th>
            <td>{{info.circulation}}</td>
          </tr>
        </tbody>
      </table>
      <h3>铭文:</h3>
      <table>
        <tbody>
          <tr>
            <th>正面</th>
            <td>{{info.frontDesc}}</td>
          </tr>
          <tr>
            <th>背面</th>
            <td>{{info.backDesc}}</td>
          </tr>
          <tr>
            <th>铸记</th>
            <td>{{info.castMark}}</td>
          </tr>
        
        </tbody>
      </table>
      <h3>备注:</h3>
      <p v-html="info.content"></p>
    </div>
    <div style="text-align:center; cursor: pointer;"><span @click="onClose">【关闭页面】</span></div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      info: {}

    }
  },
  created: function () {
    let id = this.$route.params.id;
    let that = this;
    axios.get(this.COMMON.httpUrl + '/api/article/info', {
      params: {
        id: id,
      }
    }).then(function (response) {
      var data = response.data;
      if (data.code == 200) {
        that.info = data.data[0];
        console.log(that.info);
      }

    }).catch(function (error) {
      console.log(error)
    });
  },
  methods: {
    onClose() {
      window.opener = null;
      window.open("about:blank", "_top").close();
    }
  }
}
</Script>
<style scoped>
.infoBox h2.main {
  margin-top: 24px;
  margin-bottom: 24px;
  padding-top: 10px;
  text-align: left;
  color: #404040;
  font: 32px MicrosoftYaHei Bold, MicrosoftYaHei, Arial, Hiragino Sans GB, STHeiti, Helvetica Neue, Helvetica, Microsoft Yahei, WenQuanYi Micro Hei, sans-serif
}

.infoBox .create_time {
  margin-top: 10px;
  margin-bottom: 20px;
  color: #999;
  text-align: right;
  font-size: 14px;
  border-bottom: 1px solid #999;
  padding-bottom: 10px;
}

.img {
  margin-right: 20px;
  border-radius: 10px;
}

h3 {
  font-size: 14px;
  color: #666;
  margin: 6px 0 10px 100px;
}

table {
  width: 700px;
  margin: 7px auto;
  border-collapse: collapse;
  border-spacing: 0;
}

table th {
  width: 100px;
}

table td,
table th {
  border: 0.05rem solid #AFBFC8;
  font-size: 14px;
  height: 24px;;
  font-weight: normal;
  padding: 4px 8px;
  color: #3B3B3B;
  vertical-align: middle;
}

p {
  font-size: 12px;
  margin-left: 100px;
  line-height: 150%;
}
</style>
